import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onSubmit: () => void
}

function Welcome({ onSubmit }: Props) {
  const { t } = useTranslation()
  return (
    <main className="step-0">
      <h4 className="subtitle">{t('welcome.applyInMinutes')}</h4>
      <h1>{t('welcome.prequalifiedRapidly')}</h1>
      <div className="paragraph">
        <p>{t('welcome.answerQuestions')}</p>
      </div>
      <button id="btnBegin" type="button" onClick={onSubmit} className="btn btn-blue">
        <span>{t('welcome.getStarted')}</span>
        <i className="fa-regular fa-arrow-right" />
      </button>
    </main>
  )
}

export default Welcome
